import { useSelector } from 'react-redux';
import { RootState } from '../../store/reducers';
import { useEduCapabilities } from './capabilities';

// A new staff identity or authority must never inherit another session's open content.
export function useEduStaffSession() {
    const auth = useSelector((state: RootState) => state.auth);
    const role = auth.roleName as string | null;
    const roleLoaded = auth.roleLoaded as boolean;
    const { capabilities, ready, error, refresh } = useEduCapabilities();
    const scopeKey = JSON.stringify([auth.id, auth.userId, auth.teacherId, role, roleLoaded, capabilities.accessVersion,
        capabilities.mode, capabilities.staffProfile, capabilities.canManageCatalog, capabilities.canMapModules,
        capabilities.canReviewParticipations, capabilities.canViewHistory, capabilities.canManageAccess]);
    return { role, roleLoaded, scopeKey, capabilities, ready, error, refresh };
}
